module["exports"] = [
  "#{first_name}#{last_name}"
];
